import { PROFILE } from "../data/content";

// Downloads the resume with a custom filename.
// Fetches the file as a blob, creates a blob URL, and triggers a download.
// Falls back to opening the URL in a new tab if fetch fails (e.g. CORS block).
export async function downloadResume() {
  const url = PROFILE.resumeUrl;
  const filename = PROFILE.resumeFilename || "Arya_Kadulkar_Resume.pdf";
  if (!url) return false;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error("fetch failed");
    const blob = await res.blob();
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objUrl), 1000);
    return true;
  } catch (e) {
    window.open(url, "_blank", "noopener,noreferrer");
    return false;
  }
}
